import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { HttpClientModule, HTTP_INTERCEPTORS, } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MultiSelectModule } from 'primeng/multiselect';
import { DialogModule } from 'primeng/dialog';
import {FileuploadRoutingModule} from './fileupload.routing.module';
import {FileuploadComponent} from './file-upload.component';
import {FileUploadModule} from 'primeng/fileupload';

@NgModule({
  imports: [
    FileuploadRoutingModule,
    TableModule,
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
    MultiSelectModule,
    FileUploadModule,
    DialogModule
  ],
  declarations: [
    FileuploadComponent
  ]
})
export class FileuploadModule { }
